import { createSelector } from "reselect";
import { importsSelector } from "../../imports_selector";

export const csvImportSelector = createSelector(
  importsSelector,
  imports => {
    return imports.csvImport;
  }
);
